import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    AccountGridContainer,
    AccountGrid,
    AccountDetails,
    TerritoryDiv,
} from './OnSubmit.styled';
import { accountNumberZeroTrimmer, isMobileDevice } from 'src/utils/util';
export const ALLDISTRICTS = 'ALL_Districts';
export const ALLTERRITORIES = 'All_Territories';
const Account = ({ selectedTerritory, accountId }) => {
    const validatedData = useSelector(
        (state) => state.createReceiveSetsReducer.createReceiveSets
    );
    const { t } = useTranslation();
    return (
        <AccountGridContainer
            container
            justifyContent={'space-between'}
            direction="row"
            className={'AccountSection'}
        >
            <AccountGrid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                mobile={6}
                className={'AccountDetails'}
            >
                <div>
                    <AccountDetails isDemi>
                        {t('more.common.templateDetails.district')}
                    </AccountDetails>
                    <AccountDetails className="receive-sets-account-name-dt-mask" isRegular>
                        {validatedData && validatedData?.districtName}
                        {/* {selectedDistrict &&
                        selectedDistrict.districtCode !== ALLDISTRICTS
                            ? selectedDistrict.districtName 
                            : 'NOT SELECTED'
                     } */}
                    </AccountDetails>
                </div>
            </AccountGrid>
            <AccountGrid item xs={12} sm={6} md={6} lg={6} xl={6} mobile={6}>
                <TerritoryDiv>
                    <AccountDetails isDemi>
                        {t('more.common.templateDetails.territory')}
                    </AccountDetails>
                    <AccountDetails className="receive-sets-account-number-dt-mask" isRegular>
                        {selectedTerritory && selectedTerritory.terrirotryName}
                        {/* {getTerritoryNameWithTag()} */}
                    </AccountDetails>
                </TerritoryDiv>
            </AccountGrid>
            <AccountGrid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={12}
                className={'AccountDetails'}
            >
                <div style={{ marginTop: '23px' }}>
                    <AccountDetails isDemi>
                        {t(
                            'orders.orderDetails.orderSummary.surgeryDetails.account'
                        )}
                    </AccountDetails>
                    <AccountDetails
                        className="receive-sets-contact-dt-mask"
                        isRegular
                        style={{
                            wordBreak: 'break-all',
                            display: !isMobileDevice() ? 'flex' : 'block',
                        }}
                    >
                        {accountId?.accountName}{' '}
                        <AccountDetails
                            isItalic
                            isInline
                            style={{
                                paddingLeft: isMobileDevice() ? '0px' : '5px',
                            }}
                        >
                            {accountNumberZeroTrimmer(
                                accountId?.accountId || ''
                            )}
                        </AccountDetails>
                    </AccountDetails>
                </div>
            </AccountGrid>
        </AccountGridContainer>
    );
};

export default Account;
